export default __webpack_public_path__ + "static/media/cancel-rounded.ccfd3ae3.svg";